import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { RadarGridApiFactory } from "@/api/radar-grid/apiFactory";
import Store from "@/store/store";
const rgObjRepository = RadarGridApiFactory.get("radarGridObjectRepository");
const rgBaseRepository = RadarGridApiFactory.get(
  "radarGridRadarBaseRepository"
);

class RadarGridService {
  async fetchDisplayAreas() {
    const groupId = Store.getters["auth/getRgGroupId"];
    let res = await rgBaseRepository.fetchHistoryDisplayAreas({
      radar_base_group_id: groupId,
    });

    return res.data.history_display_areas;
  }

  async fetchMyVesselIds() {
    let res = await AiseaApiFactory.get("enterpriseVessel").index();
    if (res.data.vessels.length === 0) {
      return [];
    }
    const activeVesselIds = res.data.vessels
      .filter(vessel => !vessel.disabled_at) // disabled_atがnullまたは空文字
      .map(vessel => vessel.id);
    return activeVesselIds;
  }

  async fetchAisVesselsHistory(displayArea, startedAtSec, endedAtSec) {
    const {
      south_west_latitude,
      south_west_longitude,
      north_east_latitude,
      north_east_longitude,
    } = displayArea;

    const startedAt = new Date(startedAtSec * 1000).toISOString();
    const endedAt = new Date(endedAtSec * 1000).toISOString();

    const query = {
      south_west_latitude: south_west_latitude,
      south_west_longitude: south_west_longitude,
      north_east_latitude: north_east_latitude,
      north_east_longitude: north_east_longitude,
      started_at: startedAt,
      ended_at: endedAt,
    };

    const resAisVessels = await AiseaApiFactory.get(
      "enterpriseVoyageRecords"
    ).getVesselsAndPoint(query);

    return resAisVessels.data;
  }

  async fetchRadarGridHistory(displayArea, startedAtSec, endedAtSec) {
    const {
      radar_base_group_id,
      south_west_latitude,
      south_west_longitude,
      north_east_latitude,
      north_east_longitude,
    } = displayArea;

    // UNIX秒 → ISO文字列（ミリ秒なし）
    const startedAt = new Date(startedAtSec * 1000)
      .toISOString()
      .replace(/\.000Z$/, "Z");
    const endedAt = new Date(endedAtSec * 1000)
      .toISOString()
      .replace(/\.000Z$/, "Z");

    const query = {
      radar_base_group_id: radar_base_group_id,
      south_west_latitude: south_west_latitude,
      south_west_longitude: south_west_longitude,
      north_east_latitude: north_east_latitude,
      north_east_longitude: north_east_longitude,
      started_at: startedAt,
      ended_at: endedAt,
    };

    let res = await rgObjRepository.fetchRadarGridHistory(query);

    return res.data.history;
  }
}

export default new RadarGridService();
